import { TButtonType } from '@hg/stylizator/dist/esm/components/atoms/Button/models'

interface IThemeData {
  leftButtonStyle: TButtonType
  rightButtonStyle: TButtonType
  specialTheme: boolean
}

export interface IThemeTypeData {
  default: IThemeData
  cbMintgreen: IThemeData
  cbSpecial: IThemeData
  blue: IThemeData
  dark: IThemeData
  outerSpace: IThemeData
}

export const ThemeTypeData: IThemeTypeData = {
  default: {
    leftButtonStyle: 'primary',
    rightButtonStyle: 'secondary',
    specialTheme: false,
  },
  blue: {
    leftButtonStyle: 'accent',
    rightButtonStyle: 'accent',
    specialTheme: true,
  },
  dark: {
    leftButtonStyle: 'accent',
    rightButtonStyle: 'primary',
    specialTheme: true,
  },
  cbMintgreen: {
    leftButtonStyle: 'primary',
    rightButtonStyle: 'secondary',
    specialTheme: false,
  },
  cbSpecial: {
    leftButtonStyle: 'accent',
    rightButtonStyle: 'primary',
    specialTheme: true,
  },
  outerSpace: {
    leftButtonStyle: 'accent',
    rightButtonStyle: 'accent',
    specialTheme: true,
  },
}
